module.exports = __webpack_public_path__ + "static/hr_app_cover-29b1e75b3ea602dbcdea30fb346643a1.png";